import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import de from './locales/de.json';

export const SUPPORTED_LANGS = ['en', 'de'];
export const DEFAULT_LANG = 'en';
export const LANG_STORAGE_KEY = 'vizcorn-lang';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false, // React already escapes output
  },
  returnObjects: true, // lets t('hero.capabilities', { returnObjects: true }) return the array
});

export default i18n;
